/**
 * @desc 批量删除费用请款信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: Array<number>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/costRequest/batchDelete`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
